import React from "react";
import { Helmet } from 'react-helmet';
import { graphql, Script } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Layout from "../components/layout"
import Seo from "../components/seo"

// eslint-disable-next-line
const WorkPage = ({ data }) => {
  const siteTitle = data.site.siteMetadata.title
  const social = data.site.siteMetadata.social
  const post = data.markdownRemark
  const subposts = data.allMarkdownRemark.edges
  let postCounter = 0

  return (
    <Layout title={siteTitle} social={social}>
      <Seo keywords={data.site.siteMetadata.keywords}
        title={post.frontmatter.title}
        description={post.frontmatter.description || ''}
      />
      <Script async src="https://www.googletagmanager.com/gtag/js?id=G-XJRH86MGRW"></Script>
      <Script id="ga-bio">{`window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'G-XJRH86MGRW');`}</Script>
      {data.site.siteMetadata.description && (
        <header className="page-head">
          <h2 className="page-head-title">
            {data.site.siteMetadata.description}
          </h2>
        </header>
      )}
      <article
        className={`post-content ${post.frontmatter.thumbnail || `no-image`}`}
      >
        <header className="post-content-header">
          <h1 className="post-content-title">{post.frontmatter.title}</h1>
        </header>
        {post.frontmatter.description && (
          <p className="post-content-excerpt">{post.frontmatter.description}</p>
        )}
      </article>

      {subposts.map(({ node }) => {
            postCounter++
            return (
                <div className="work-container" >
                  <div className="image-container">
                    <figure key={`image-${postCounter}`} className="work-image">
                      <GatsbyImage
                        image={getImage(node.frontmatter.thumbnail)}
                        alt={`Gallery image ${postCounter}`} // Replace with actual alt text
                      />
                    </figure>
                  </div>
                  <div className="description-container">
                      <p><strong>{node.frontmatter.title}</strong></p>
                      <p>{node.frontmatter.description}</p>
                  </div>
                </div>
                // <PostCard
                //     key={node.fields.slug}
                //     count={postCounter}
                //     node={node}
                //     postClass={`post`}
                // />
            )
        })}

        <h2 className="bio-title" style={{ textAlign: 'center' }}>Selected Interaction Prototypes</h2>
        
        <div className="work-container">
          <div className="video-container">
            <VimeoEmbed videoId="883012144" />
            <figcaption>AcousticMario, 2019.</figcaption>
          </div>

          <div className="video-container">
            <VimeoEmbed videoId="883019786" />
            <figcaption>Gyrotify, 2019.</figcaption>
          </div>
        </div>

        <div className="work-container">
          <div className="video-container">
            <VimeoEmbed videoId="884226697" />
            <figcaption>"I Am a Bird", 2019.</figcaption>
          </div>

          <div class="video-container">
              <iframe width="100%" height="270" src="https://www.youtube.com/embed/IsWzZN8kHc4?si=-sOpjoW8Z4WdPb5e" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              <figcaption>Touchboard Controlled Angry Bird, 2019.</figcaption>
          </div>
        </div>
    </Layout>
  )
}
export default WorkPage

const VimeoEmbed = ({ videoId }) => {
  const iframe = `<iframe src="https://player.vimeo.com/video/${videoId}?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Video"></iframe>`;

  return (
    <>
      <Helmet>
        <script src="https://player.vimeo.com/api/player.js"></script>
      </Helmet>
      <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%' /* 16:9 Aspect Ratio */ }}>
        <div dangerouslySetInnerHTML={{ __html: iframe }} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} />
      </div>
    </>
  );
};


export const WorkPageQuery = graphql`
query IndexPage {
  site {
    siteMetadata {
      title
      author
      social{
        twitter
        facebook
      }
    }
  }
  markdownRemark(frontmatter: {templateKey: {eq: "work-page"}}) {
    frontmatter {
      title
      description
      thumbnail {
        childImageSharp {
          fluid(maxWidth: 1360) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
    
  }
  allMarkdownRemark(
    filter: {frontmatter: {templateKey: {eq: "work-sub-page"}}}
    limit: 30
    sort: {frontmatter: {date: DESC}}
  ) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          date(formatString: "DD:MM:YYYY hh:mm a")
          title
          description
          thumbnail {
            childImageSharp {
              gatsbyImageData(quality: 100, width: 600)
            }
          }
        }
      }
    }
  }
}
`;